import { createContext, ReactNode, useState } from "react";
import { Mission2, MissionWorkflowType } from '../Types';
import { transformMissionWorkflowFromSettingsToReactNodes } from "../TransformMissionWorkflow/TransformMissionWorkflowFromSettingsToReactNodes";
import { mapping } from "../TransformMissionWorkflow/Mapping";
const w = window as any

interface Mission2ViewContextType {
    mission2View: any;
}

export const Mission2ViewContext = createContext<Mission2ViewContextType>({
    mission2View: null,
});

export function TempWrapper({ Mission2View }: { Mission2View: any }) {
    // TODO: Maybe we don't even need state?

    function localMission() {
        const id = parseInt(Mission2View.missionId)
        const missions = w.XopsLocalStorage.getMissions();
        const missionIndex = missions.findIndex((mission: Mission2) => mission.id === id);
        const mission = missions[missionIndex]
        return mission
    }

    const mission = localMission();
    const workflow = w.XopsGlobals.getInstance().getEventSettingsMap()[mission.type.id];

    /* This line must be perform when using a missionWorkflow from EventSettings
    of the localStorage because the "type" key is missing. */
    Object.assign(workflow, { "type": "MissionWorkflow" });

    const [missionWorkflowComponent, setMissionWorkflowComponent] = useState<ReactNode>(transformMissionWorkflowFromSettingsToReactNodes(mapping, workflow, { mission }));

    return (
        <>
            <Mission2ViewContext.Provider value={{ mission2View: Mission2View }}>
                {missionWorkflowComponent}
            </Mission2ViewContext.Provider>
        </>
    );
}
